import html_iway from "./template.iway.html?raw"
import html_lic from "./template.lic.html?raw"
import html_sak from "./template.sak.html?raw"
const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme){
    html = html_iway
} else if ("lic" == app_theme){
   html = html_lic
} else if ("sak" == app_theme){
    html = html_sak
}
import LanguageSwitch from "../Shared/LanguageSwitch/index.ts";
import Navigation from "../Shared/Navigation/index.ts";
export default{
    template: html,
    components: {LanguageSwitch, Navigation},
    setup() {
        const isDarkmode = false;
        return {
            isDarkmode
        }

    }

}